import { Typography } from '@euler/app/components/typography';
import { tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { LucideIcon } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';

/** A small tinted label, e.g. `默认` or `门店可见`. */
export const BiTag = memo(
  ({
    text,
    color,
    icon: Icon,
  }: {
    text: string;
    color: string;
    icon?: LucideIcon;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: rpx(4),
          paddingHorizontal: rpx(8),
          paddingVertical: rpx(2),
          borderRadius: rpx(10),
          backgroundColor: tint(color, 0.1),
        }}
      >
        {Icon ? <Icon size={11} color={color} /> : null}
        <Typography.Text medium size={rpx(11)} color={color}>
          {text}
        </Typography.Text>
      </View>
    );
  },
);
